{
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "close": "Close",
  "edit": "Edit",
  "update": "Update",
  "register": "Register",
  "back": "Back",
  "loading": "Loading",
  "noData": "No data"
}
